/**
 * Inline variant of FeatureLocked — sits in a dashboard grid where a chart or
 * panel would be, so the tenant sees what the next plan adds in context.
 */

import { useEntitlements } from "@/contexts/EntitlementsContext";

/**
 * @param {{ feature: string, title?: string, subtitle?: string }} props
 */
export default function FeatureLockedCard({ feature, title, subtitle }) {
  const { lockInfo } = useEntitlements();
  const info = lockInfo(feature);
  if (!info) return null;

  return (
    <div className="rounded-brand-lg border border-dashed border-slate-300 bg-slate-50/60 p-5 dark:border-slate-700 dark:bg-slate-900/40">
      <div className="mb-2 flex items-center gap-2">
        <i className="ri-lock-2-line text-sm text-slate-500 dark:text-slate-400" aria-hidden="true" />
        <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-200">
          {title || info.label}
        </h3>
      </div>

      <p className="mb-4 text-xs leading-relaxed text-slate-600 dark:text-slate-400">
        {subtitle || `Included in ${info.requiredPlanLabel}. Upgrade to turn on ${info.label}.`}
      </p>

      <a
        href={info.contactUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-teal-700 transition hover:text-teal-800 dark:text-teal-400 dark:hover:text-teal-300"
      >
        Discuss upgrading
        <i className="ri-arrow-right-line" aria-hidden="true" />
      </a>
    </div>
  );
}
